module.exports = __webpack_public_path__ + "img/Burgerland Logo Icon_500px.6bd78d2e.png";